import React, { useState, useCallback, useEffect } from "react";
import { Switch, Tooltip, CircularProgress } from "@mui/material";
import PropTypes from "prop-types";

import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";

const SwitchToggle = ({ portId, currentStatus, onChangeStatus, disabled, statusChanging }) => {
  const [isChanging, setIsChanging] = useState(false);
  const [localStatus, setLocalStatus] = useState(currentStatus);

  // Sincronizar el estado local con el prop currentStatus
  useEffect(() => {
    setLocalStatus(currentStatus);
  }, [currentStatus]);

  const handleToggle = useCallback(async () => {
    if (disabled || statusChanging || isChanging) return;

    setIsChanging(true);
    try {
      // Llamar a la función del padre para cambiar el estado en el servidor
      const success = await onChangeStatus(portId, localStatus);

      // Si falla la petición, revertir el estado
      if (success) setLocalStatus(!localStatus);
    } catch (error) {
      // Si hay error, revertir el estado
      setLocalStatus(localStatus);
      console.error("Error al cambiar estado:", error);
    } finally {
      setIsChanging(false);
    }
  }, [portId, localStatus, onChangeStatus, disabled, statusChanging, isChanging]);

  const loading = isChanging || statusChanging;

  return (
    <Tooltip
      title={localStatus ? "Desactivar reinicio automático" : "Activar reinicio automático"}
      arrow
    >
      <MDBox display="flex" alignItems="center">
        {loading ? (
          <CircularProgress size={20} />
        ) : (
          <Switch
            checked={localStatus}
            onChange={handleToggle}
            disabled={disabled || loading}
            color={localStatus ? "success" : "default"}
          />
        )}
        <MDTypography
          variant="caption"
          ml={1}
          color={localStatus ? "success" : "text"}
          fontWeight="bold"
          sx={{ minWidth: "100px" }}
        >
          {loading ? "CAMBIANDO…" : localStatus ? "HABILITADO" : "DESHABILITADO"}
        </MDTypography>
      </MDBox>
    </Tooltip>
  );
};

SwitchToggle.propTypes = {
  portId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  currentStatus: PropTypes.bool.isRequired,
  onChangeStatus: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  statusChanging: PropTypes.bool,
};

SwitchToggle.defaultProps = {
  disabled: false,
  statusChanging: false,
};

export default React.memo(SwitchToggle);
